import Validator from '../Validator';
import ValidatorInterface from '../ValidatorInterface';
import DataVariableInterface from "../../../DataVariables/ts/DataVariableInterface";

export default class ValidatorNumber extends Validator implements ValidatorInterface {

    private readonly positiveInteger: boolean;

    /**
     * Constructor, determine if the email has to be unique
     *
     * @param dataVariable
     */

    public constructor(dataVariable: DataVariableInterface) {

        super(dataVariable);

        this.positiveInteger = false;

        // POINTS_BALANCE
        if (dataVariable.uuid == '7bKVueK9A2FomeRePAiKyR') {
            this.positiveInteger = true;
        }

        // RECRUITMENT_SOURCE
        if (dataVariable.uuid == '4baRCRCx4YBJhnEEWRsHd2') {
            this.positiveInteger = true;
        }

        // LOCALE
        if (dataVariable.uuid == 'GKIPtxsC0c33qz8aAlqtC') {
            this.positiveInteger = true;
        }
    }

    /**
     * Check if value is valid
     *
     * @param value
     * @param index
     * @param offset
     */

    public check(value: string, index: number, offset: number): boolean {

        if (!this.isNumeric(value)) {
            this.addError("Non numeric value detected", index, value);
            return false;
        }

        if (this.positiveInteger) {
            if (!Number.isInteger(parseInt(value))) {
                this.addError("Non numeric value detected", index, value);
                return false;
            }
        }

        return true;
    }
}